import React, { createContext, useState, useEffect, useContext } from 'react';
import { AppVarsContext } from '../context/AppVarsContext';

// Create the context
export const UserContext = createContext();

// Create the provider
export const UserProvider = ({ children }) => {
    const { appVars } = useContext(AppVarsContext);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const client = JSON.parse(sessionStorage.getItem('client'));
    const publicReportSlug = sessionStorage.getItem('reportSlug') || '';
    


useEffect(() => {
    if (!appVars?.api_url || !client?.owner) return;

    let cancelled = false;

    const fetchData = async () => {
        try {
            const endpoint = publicReportSlug
                ? `${appVars.api_url}/public/report/representative?cid=${encodeURIComponent(sessionStorage.getItem('rid') || '')}`
                : `${appVars.api_url}/users/g/${client.owner}`;
            const res = await fetch(endpoint, publicReportSlug ? { headers: { 'X-Report-Slug': publicReportSlug } } : undefined);
            const data = await res.json();
            if (!cancelled) {
                setUser(Array.isArray(data) ? data[0] : data);
            }
        } catch (err) {
            console.error('Error fetching user:', err);
        } finally {
            if (!cancelled) {
                setLoading(false);
            }
        }
    };

    fetchData();

    return () => {
        cancelled = true;
    };
}, [appVars?.api_url, client?.owner, publicReportSlug]); // ✅ only trigger when these change

    return (
        <UserContext.Provider value={{ user, loading }}>
            {children}
        </UserContext.Provider>
    );
};

// ✅ Add this export for the hook
export const useUserProfile = () => useContext(UserContext);
